import style from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { SuccessIconSvg } from '@/components/UI/svg/airConditioner';

let timer: any;

export default function SuccessDialog({ closeSuccDialog, isRecommend, isCalculator }: any) {
    const dialogShowTime = 5;
    const { useState, useLang, useEffect } = useGlobal();

    const { t } = isRecommend ? useLang('powerkitsrecommend') : isCalculator ? useLang('shared') : useLang('ecoflowpowerkitsseries');

    // 弹窗消失剩余时间
    const [leftTime, setLeftTime] = useState(dialogShowTime);

    const timeRuning = (leftTime: number) => {
        timer = setTimeout(() => {
            setLeftTime(leftTime - 1);
            if (leftTime > 1) {
                timeRuning(leftTime - 1);
            } else {
                closeSuccDialog();
            }
        }, 1000);
    };

    const closeSuccessDialog = () => {
        clearTimeout(timer);
        closeSuccDialog();
    };
    const openSuccessDialog = () => {
        setLeftTime(dialogShowTime);
        timeRuning(dialogShowTime);
    };

    useEffect(() => {
        openSuccessDialog();
    }, []);

    return (
        <div className={style.successDialog}>
            <div className="success-dialog">
                <div className="success-icon">
                    <SuccessIconSvg width="102px" height="102px" />
                </div>
                <div className="success-msg">{t('presale.preorder.success_tips')}</div>
                <div className="subtips">{t('presale.preorder.success_sub_tips')}</div>
                <div className="succ-btn-wrapper">
                    <button onClick={() => closeSuccessDialog()} className="btn can-submit" type="button">
                        {`${t('presale.comments.got_it')} (${leftTime}${t('presale.comments.seconds')})`}
                    </button>
                </div>
            </div>
        </div>
    );
}
